/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ActionType {
  None = 'None',
  VerifyOtp = 'VerifyOtp',
  ResetPassword = 'ResetPassword'
}
